import { z } from 'zod';
import { Strings } from '../constants';

const strings = Strings.get();

export const reportUserSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, strings.ui.reportUser.validation.reasonRequired)
    .max(500, strings.ui.reportUser.validation.reasonTooLong),
});

export type ReportUserFormValues = z.infer<typeof reportUserSchema>;


